import { Button, Grid, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';

export const RegisterButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.button.primary.background,
  color: theme.palette.button.primary.color,
  '&:hover': {
    backgroundColor: theme.palette.button.primary.backgroundHover
  },
  height: "50px",
  width: "100%",
}));

export const ErrorGrid = styled(Grid)(({ theme }) => ({
  marginBottom: 20,
  color: theme.palette.error.main,
  marginLeft: 55,
  "&>p": {
    fontSize: 17
  },
  "&>p:first-child": {
    fontWeight: "bold"
  }
}));

export const CountryTypography = styled(Typography)({
  fontWeight: "bold",
  color: "gray",
  fontSize: "10px"
});

export const SuccessTextGrid = styled(Grid)({
  fontSize: "17px",
  margin: "10px"
});

export const SuccessButton = styled(Button)(({ theme }) => ({
  marginTop: "15px",
  borderRadius: "4px",
  backgroundColor: theme.palette.dialog.primaryButton.background,
  color: theme.palette.dialog.primaryButton.color,
  '&:hover': {
    backgroundColor: theme.palette.dialog.primaryButton.backgroundHover
  },
}));